import { systemMailBusinessResendAllowed, systemMailStatusLabel } from "./SystemMailStatus";

export const accountMailLabel = (status, lang = "de") => status ? systemMailStatusLabel(status, lang) : "";
export const accountMailResendAllowed = systemMailBusinessResendAllowed;
